export enum TodoStatus {
  All,
  Active,
  Completed,
  "In Progress",
  Paused
};
